module.exports = __webpack_public_path__ + "img/shield.3bd9aa30.png";